import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Map old WordPress/WooCommerce URLs to new pages
const REDIRECT_MAP = {
  // Old trip pages -> new landing pages
  "/trip/sightseeing-tours": "/hollywood-sightseeing-tours",
  "/trip/sightseeing-tours/": "/hollywood-sightseeing-tours",
  "/trip/hollywood-fame-tour": "/best-hollywood-tours",
  "/trip/hollywood-fame-tour/": "/best-hollywood-tours",
  "/trip/hollywood-tour": "/hollywood-tour",
  "/trip/hollywood-tour/": "/hollywood-tour",
  "/trip/celebrity-homes-tour": "/celebrity-homes-tour-hollywood",
  "/trip/celebrity-homes-tour/": "/celebrity-homes-tour-hollywood",
  "/trip/walk-of-fame-tour": "/hollywood-walk-of-fame-tour",
  "/trip/walk-of-fame-tour/": "/hollywood-walk-of-fame-tour",
  "/trip/bus-tour": "/hollywood-bus-tours",
  "/trip/bus-tour/": "/hollywood-bus-tours",
  "/trip/vegas-to-hollywood": "/las-vegas-to-hollywood-tour",
  "/trip/vegas-to-hollywood/": "/las-vegas-to-hollywood-tour",
  "/trip/private-tour": "/private-hollywood-tours",
  "/trip/private-tour/": "/private-hollywood-tours",
  "/trip/disneyland-tour": "/hollywood-to-disneyland-tour",
  "/trip/disneyland-tour/": "/hollywood-to-disneyland-tour",

  // Old WP pages -> homepage sections or landing pages
  "/about-us": "/#tours",
  "/about-us/": "/#tours",
  "/contact-us": "/#contact",
  "/contact-us/": "/#contact",
  "/cart": "/#book",
  "/cart/": "/#book",
  "/checkout": "/#book",
  "/checkout/": "/#book",
  "/shop": "/#tours",
  "/shop/": "/#tours",
  "/my-account": "/#contact",
  "/my-account/": "/#contact",
  "/affiliates-vendors": "/",
  "/affiliates-vendors/": "/",
  "/langs": "/hollywood-tours-for-international-visitors",
  "/langs/": "/hollywood-tours-for-international-visitors",
  "/book-now": "/#book",
  "/book-now/": "/#book",
  "/tours": "/#tours",
  "/tours/": "/#tours",
  "/booking": "/#book",
  "/booking/": "/#book",

  // Additional GSC-flagged old URLs
  "/all-trips": "/#tours",
  "/all-trips/": "/#tours",
  "/feed": "/",
  "/feed/": "/",
  "/wp-json": "/",
  "/wp-json/": "/",
  "/hollywood-day-trip-from-las-vegas": "/hollywood-day-trip-from-las-vegas",
};

// Pattern-based redirects for dynamic old URLs
const PATTERN_REDIRECTS = [
  { pattern: /^\/trip\//, target: "/hollywood-tours" },
  { pattern: /^\/product\//, target: "/hollywood-tours" },
  { pattern: /^\/product-category\//, target: "/hollywood-tours" },
  { pattern: /^\/(wp-admin|wp-content|wp-includes|wp-json)\//, target: "/" },
  { pattern: /^\/\?wc-ajax=/, target: "/" },
  { pattern: /^\/\?add-to-cart=/, target: "/#book" },
  { pattern: /^\/feed\//, target: "/" },
  { pattern: /\?wc-ajax/, target: "/" },
  { pattern: /%%endpoint%%/, target: "/" },
];

const OldUrlRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fullPath = location.pathname + location.search;

  useEffect(() => {
    // Check exact match first
    const exactTarget = REDIRECT_MAP[location.pathname];
    if (exactTarget) {
      window.location.replace(exactTarget);
      return;
    }

    // Check pattern matches
    for (const { pattern, target } of PATTERN_REDIRECTS) {
      if (pattern.test(fullPath)) {
        window.location.replace(target);
        return;
      }
    }

    // No redirect found — redirect to homepage (never show a 404 page to search engines)
    window.location.replace("/");
  }, [location.pathname, fullPath, navigate]);

  // Brief loading state while redirect executes
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center max-w-lg">
        <p className="text-gray-600">Redirecting to Official Hollywood Tours...</p>
      </div>
    </div>
  );
};

export { REDIRECT_MAP, PATTERN_REDIRECTS };
export default OldUrlRedirect;
